module.exports = __webpack_public_path__ + "static/media/figure_mobile_one.12890eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/figure_mobile_one.png
// module id = 333
// module chunks = 0